import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from 'antd';

import './ErrorPage.css';
const { Title, Text } = Typography;

const ErrorPage = ({
                       statusCode = 404,
                       title = 'Страница не найдена',
                       description = 'Такой страницы не существует',
                       showButton = true
                   }) => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/');
    };

    return (
        <div className="error-page-container">
            <div className="error-page-content">
                <div className="error-image-container">
                    <svg
                        className="logo-left"
                        width="188"
                        height="117"
                        viewBox="0 0 188 117"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M101.996 87.235L101.996 117L129.496 117C161.805 117 187.996 90.8087 187.996 58.5C187.996 26.1913 161.805 4.08925e-06 129.496 -1.50473e-07L101.996 -3.75918e-06L101.996 29.5364L155.06 29.5364L155.06 87.235L101.996 87.235Z"
                            fill="#05D32A"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M86 29.765L86 1.02554e-06L58.5 6.97606e-07C26.1913 -7.31707e-06 3.56916e-06 26.1913 6.97606e-07 58.5C-2.50923e-06 90.8087 26.1913 117 58.5 117L86 117L86 87.4636L32.9362 87.4636L32.9362 29.765L86 29.765Z"
                            fill="#05D32A"
                        />
                    </svg>
                    <svg
                        className="blur-background"
                        width="186"
                        height="186"
                        viewBox="0 0 186 186"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g filter="url(#filter0_b_0_1)">
                            <rect
                                x="185.996"
                                y="186"
                                width="186"
                                height="186"
                                rx="5"
                                transform="rotate(-180 185.996 186)"
                                fill="url(#paint0_linear_0_1)"
                                fillOpacity="0.6"
                            />
                            <rect
                                x="185.996"
                                y="186"
                                width="186"
                                height="186"
                                rx="5"
                                transform="rotate(-180 185.996 186)"
                                fill="#E9EBEC"
                                fillOpacity="0.2"
                            />
                            <rect
                                x="185.496"
                                y="185.5"
                                width="185"
                                height="185"
                                rx="4.5"
                                transform="rotate(-180 185.496 185.5)"
                                stroke="url(#paint1_radial_0_1)"
                            />
                            <rect
                                x="185.496"
                                y="185.5"
                                width="185"
                                height="185"
                                rx="4.5"
                                transform="rotate(-180 185.496 185.5)"
                                stroke="url(#paint2_linear_0_1)"
                            />
                        </g>
                        <defs>
                            <filter
                                id="filter0_b_0_1"
                                x="-20.0039"
                                y="-20"
                                width="226"
                                height="226"
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                            >
                                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
                                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1" result="shape"/>
                            </filter>
                            <linearGradient
                                id="paint0_linear_0_1"
                                x1="207.961"
                                y1="204.04"
                                x2="385.509"
                                y2="320.968"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="white" stopOpacity="0.4"/>
                                <stop offset="1" stopColor="#999999" stopOpacity="0"/>
                            </linearGradient>
                            <radialGradient
                                id="paint1_radial_0_1"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(308.353 192.878) rotate(114.316) scale(179.881 231.728)"
                            >
                                <stop stopColor="#959AA4" stopOpacity="0.3"/>
                                <stop offset="0.940761" stopColor="#FFFFF9" stopOpacity="0.5"/>
                            </radialGradient>
                            <linearGradient
                                id="paint2_linear_0_1"
                                x1="326.548"
                                y1="203.443"
                                x2="203.989"
                                y2="265.647"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="white" stopOpacity="0.2"/>
                                <stop offset="1" stopColor="white" stopOpacity="0"/>
                            </linearGradient>
                        </defs>
                    </svg>
                    <Text type="secondary" className="status-code">{statusCode}</Text>
                </div>
                <Title level={2}>{title}</Title>
                <Text type="secondary">{description}</Text>
                {showButton && (
                    <div className="error-button-container">
                        <Button type="primary" size="large" onClick={handleButtonClick} className="error-button">
                            Вернуться в главное меню
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ErrorPage;